export const USAGE_DURATIONS = [
  { value: "1h", label: "۱ ساعت" },
  { value: "6h", label: "۶ ساعت" },
  { value: "24h", label: "۲۴ ساعت" },
  { value: "48h", label: "۴۸ ساعت" },
  { value: "1w", label: "۱ هفته" },
  { value: "1mo", label: "۱ ماه" },
  { value: "1y", label: "۱ سال" },
];

export const USAGE_DURATION_SECONDS: Record<string, number> = {
  "1h": 3600,
  "6h": 21600,
  "24h": 86400,
  "48h": 172800,
  "1w": 604800,
  "1mo": 2592000,
  "1y": 31536000,
};

export const USAGE_DURATION_STORAGE_KEY = "asha.usage.duration";

export function loadUsageDuration(): string {
  const saved = localStorage.getItem(USAGE_DURATION_STORAGE_KEY);
  return saved && USAGE_DURATIONS.some((d) => d.value === saved) ? saved : "1w";
}

export const LOGS_DURATION_STORAGE_KEY = "asha.logs.duration";

export function loadLogsDuration(): string {
  const saved = localStorage.getItem(LOGS_DURATION_STORAGE_KEY);
  return saved && USAGE_DURATIONS.some((d) => d.value === saved) ? saved : "1w";
}

export const DASHBOARD_DURATIONS = [
  { value: "1h", label: "۱ ساعت اخیر" },
  { value: "today", label: "۲۴ ساعت اخیر" },
  { value: "7d", label: "۷ روز اخیر" },
  { value: "30d", label: "۳۰ روز اخیر" },
  { value: "1y", label: "سال اخیر" },
  { value: "all", label: "همه" },
];

export const DASHBOARD_METRICS = [
  { value: "tokens", label: "توکن‌ها" },
  { value: "spend", label: "هزینه" },
  { value: "requests", label: "درخواست‌ها" },
] as const;

export type DashboardMetric = (typeof DASHBOARD_METRICS)[number]["value"];

export const DASHBOARD_DURATION_STORAGE_KEY = "asha.dashboard.duration";

export function loadDashboardDuration(): string {
  const saved = localStorage.getItem(DASHBOARD_DURATION_STORAGE_KEY);
  return saved && DASHBOARD_DURATIONS.some((d) => d.value === saved) ? saved : "7d";
}
